

























import { Vue, Component } from 'vue-property-decorator'
import {
  LifeInsuranceBenefitInfos,
  ProductCfg,
  OutputFormInfo,
} from '@/types/newPersion'
import { PonitXYInside } from '@/types/common/g2Charts'
import { insuranceList } from '@/api/newPersion'
import { CommonMudule } from '@/store/modules/common'
import { maxNumber } from '@/utils/baseFn'
import TableWrap from '@/views/newPension/productCard/tableWrap/index.vue'
import InsideBarChartWrap from '@/views/newPension/productCard/insideBarChartWrap/index.vue'
import ProductOutFormInfo from '@/views/newPension/productCard/productOutFormInfo/index.vue'
import cardWraper from '@/common/cardMap/cardLayout/cardWraper.vue'
@Component({
  components: {
    TableWrap,
    InsideBarChartWrap,
    ProductOutFormInfo,
    cardWraper,
  },
})
export default class OutputPage extends Vue {
  data = [];
  productOptInfo = {};
  productCfg = (this.$attrs.proCfg as unknown) as ProductCfg;
  editSettings = this.productCfg.editSettings;
  created () {
    console.log(this.editSettings, 1212)
    this.getPensionInsuranceSummaryList()
  }

  async getPensionInsuranceSummaryList () {
    // const res = await insuranceList({
    //   customerId,
    //   insuranceType: 'LifeInsurance',
    //   storyLineType: 'Pension',
    // })

    const _form = {
      customerId: CommonMudule.customerId,
      insuranceType: this.productCfg.insuranceType,
      storyLineType: this.productCfg.planType,
    }
    const res = await this.editSettings.countUrlFn(_form, insuranceList)
    if (res?.data) {
      const _data = res.data
      _data.forEach(
        (w: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          [propName: string]: any
        }) => {
          const chartList: PonitXYInside[] = []
          let _infoList: LifeInsuranceBenefitInfos[] = []
          if (this.productCfg.subType === 'life') {
            _infoList = w.lifeInsuranceStatistics.lifeInsuranceBenefitInfos
          } else {
            _infoList = w.insuranceStatistics.insuranceInfoList
          }
          _infoList.forEach((v: LifeInsuranceBenefitInfos) => {
            for (const k in this.editSettings.chartEnum) {
              if (k !== 'age') {
                chartList.push({
                  x: v.age + '',
                  y: v[k],
                  type: this.editSettings.chartEnum[k],
                })
              }
            }
          })
          w.chartData = chartList
          w.tableData = _infoList
          const _productOptInfo: OutputFormInfo[] = []
          if (this.productCfg?.outputSetting?.formInfoList) {
            const _formInfoList = this.productCfg.outputSetting.formInfoList
            _formInfoList.forEach((item: OutputFormInfo) => {
              const _splitList = item.value.split('.')

              let _value = w
              for (let i = 0; i < _splitList.length; i++) {
                _value = _value[_splitList[i]]
              }
              _productOptInfo.push({
                ...item,
                value: (_value as unknown) as string,
              })
            })
          }
          w.productOptInfo = _productOptInfo
          w.chartOptions = {
            position: [chartList[0].x, maxNumber(chartList, 'y')],
            legendPosition: 'top',
            titleNextContent: '岁',
            stackContent: '',
            valueNextContent: '(元)',
            annotationContent: '单位:元',
          }
        }
      )
      // }
      //  else {
      //   (_data
      //     ?.insuranceInfoList as LifeInsuranceBenefitInfos[]).forEach(
      //     (w: {
      //       // eslint-disable-next-line @typescript-eslint/no-explicit-any
      //       [propName: string]: any
      //     }) => {
      //       const chartList: PonitXYInside[] = []
      //       for (const k in this.editSettings.chartEnum) {
      //         if (k !== 'age') {
      //           chartList.push({
      //             x: w.age + '',
      //             y: w[k],
      //             type: this.editSettings.chartEnum[k],
      //           })
      //         }
      //       }
      //     }
      //   )
      // }
      this.data = _data
      // debugger

      // this.chartOptions.position = [chartList[0].x, maxNumber(chartList, 'y')]
      // this.chartData = chartList
    }

    // ----
    // if (res?.data) {
    //   const _data = res.data
    //   _data.forEach(
    //     (w: {
    //       // eslint-disable-next-line @typescript-eslint/no-explicit-any
    //       [propName: string]: any
    //     }) => {
    //       const chartList: PonitXYInside[] = []
    //       w.lifeInsuranceStatistics.lifeInsuranceBenefitInfos.forEach(
    //         (v: LifeInsuranceBenefitInfos) => {
    //           for (const k in ChartEnum2) {
    //             if (k !== 'age') {
    //               chartList.push({
    //                 x: v.age + '',
    //                 y: v[k],
    //                 type: ChartEnum2[k],
    //               })
    //             }
    //           }
    //         }
    //       )
    //       w.chartData = chartList
    //       w.productOptInfo = [
    //         {
    //           title: '产品名:',
    //           value: w.insuranceName,
    //           unit: '',
    //         },
    //         {
    //           title: '被保险人:',
    //           value: w.insuredName,
    //           unit: '',
    //         },
    //         {
    //           title: '年缴保费:',
    //           value: w.yearlyAmount,
    //           unit: '元',
    //         },
    //         {
    //           title: '期末身故保额:',
    //           value: w.lifeInsuranceStatistics.lifeBenefits,
    //           unit: '元',
    //         },
    //         {
    //           title: '期末现金价值:',
    //           value: w.lifeInsuranceStatistics.cashValue,
    //           unit: '元',
    //         },
    //         {
    //           title: '期末身故保额/总保费:',
    //           value: w.lifeInsuranceStatistics.totalPremium,
    //           unit: '倍',
    //         },
    //         {
    //           title: '期末现金价值/总保费:',
    //           value: w.lifeInsuranceStatistics.valueMultiple,
    //           unit: '倍',
    //         },
    //       ]
    //       w.chartOptions = {
    //         position: [chartList[0].x, maxNumber(chartList, 'y')],
    //         legendPosition: 'top',
    //         titleNextContent: '岁',
    //         stackContent: '',
    //         valueNextContent: '(元)',
    //         annotationContent: '单位:元',
    //       }
    //     }
    //   )
    //   this.data = _data
    //   console.log(_data)
    // }
  }
}
